module.exports = __webpack_public_path__ + "img/hopeforchildren.e8a41a2e.png";